import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import { localize } from 'helpers/translator'
import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import Bodymovin from 'components/bodymovin/bodymovin'
import binderActions from 'redux/actions/binderActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import bindersOnboardingSelector from 'redux/selectors/binders/binders_onboarding_selector'

import styles from './binders_welcome_overlay.scss'
import subplan from 'assets/views/binders/welcome/subplan-icon.svg'

class BindersWelcomeOverlay extends PureComponent {

	constructor() {
		super()
		this.listeners = {
			onComplete: this.animationCompleted.bind(this),
		}
		this.startTime = Date.now()
	}

	createTitle = () => {
		if (this.props.step === 0) {
			return (
				<span styleName='title'>
					<strong styleName='strong'>{localize('binders_welcome_overlay_title_step0_part1')} </strong><br />
					{localize('binders_welcome_overlay_title_step0_part2')}
				</span>
			)
		}
		if (this.props.step === 1) {
			return (
				<span styleName='title'>
					<strong styleName='strong'>{localize('binders_welcome_overlay_title_step1_part1')} </strong><br />
					{localize('binders_welcome_overlay_title_step1_part2')}
				</span>
			)
		}
	}

	createPrimaryTextButton = () => {
		if (this.props.step === 0)
			return localize('binders_welcome_overlay_primary_text_button_step0')
		if (this.props.step === 1)
			return localize('binders_welcome_overlay_primary_text_button_step1')
	}

	createAsset = () => {
		if (this.props.step === 0) {
			return (
				<div styleName='asset-video'>
					<iframe src='https://player.vimeo.com/video/234373507?color=ffffff&autoplay=1&title=0&byline=0&portrait=0&muted=1' allow='autoplay' width='100%' height='300px'></iframe>
				</div>
			)
		}
		if (this.props.step === 1) {
			return (
				<div styleName='asset-image'>
					<Isvg src={subplan} cacheGetRequests={true} />
				</div>
			)
		}
		if (this.props.step === 2) {
			return (
				<Bodymovin
					path='/assets/media/animations/invites.json'
					listeners={this.listeners}
				>
					<div style={{
						width: this.props.assetWidth,
						height: this.props.assetHeight,
					}}></div>
				</Bodymovin>
			)
		}
		return null
	}

	gotToNextStep = () => this.props.actions.goToOnboardingStep(this.props.step + 1, Math.floor((Date.now() - this.startTime)/1000))

	animationCompleted = () => this.props.actions.animationCompleted()

	render() {

		return (
			<FullOverlay
				headerWithBorder={true}
				title={this.createTitle()}
				assetHeight='300px'
				assetSource={this.createAsset()}
				primaryTextButton={this.createPrimaryTextButton()}
				primaryActionHandler={this.gotToNextStep}
			/>
		)
	}
}

function mapStateToProps(state) {
	return bindersOnboardingSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		goToOnboardingStep: binderActions.goToOnboardingStep,
		animationCompleted: binderActions.animationCompleted,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(BindersWelcomeOverlay, styles, {allowMultiple: true}))
